import { useState } from "react";
import "./CreditCardForm.css";
import { getCardProviderTags } from "./creditCardProviderTags";

const formatCardExpiry = (expiry) => {
  if (!expiry) {
    return "";
  }

  const date = new Date(expiry);
  if (Number.isNaN(date.getTime())) {
    return expiry;
  }

  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = String(date.getFullYear()).slice(-2);
  return `${month}/${year}`;
};

const formatSavedCardLabel = (card) => {
  const expiry = formatCardExpiry(card.exp);
  return expiry ? `${card.pan} · ${expiry}` : card.pan;
};

function WithdrawalCreditCardForm({
  onSubmit,
  userCards,
  selectedPaymentOption
}) {
  const [cardTokenData, setCardTokenData] = useState({
    card: (userCards && userCards[0]) || null
  });

  const handleCardTokenDataChange = (e) => {
    const { name, value } = e.target;
    setCardTokenData((prevData) => ({
      ...prevData,
      [name]: value
    }));
  };

  const handleSubmitSavedCard = async (e) => {
    e.preventDefault();

    console.log("Form submitted with token:", cardTokenData);
    if (typeof onSubmit === "function") {
      await onSubmit(cardTokenData);
    }
  };

  const filteredUserCards = selectedPaymentOption?.initParams?.providerId
    ? userCards.filter((card) =>
        card.tokens.some(
          (token) =>
            token.providerId === selectedPaymentOption.initParams.providerId
        )
      )
    : userCards;

  return (
    <form className="credit-card-form" onSubmit={handleSubmitSavedCard}>
      <label>{"Select from saved cards"}</label>
      <div id="saved_cards_container">
        {filteredUserCards
          .sort((a, b) => {
            if (!a.lastUsed && !b.lastUsed) return 0;
            if (!a.lastUsed) return 1;
            if (!b.lastUsed) return -1;
            return (
              new Date(b.lastUsed).getTime() - new Date(a.lastUsed).getTime()
            );
          })
          .map((card, index) => {
            const providerTags = getCardProviderTags(card);

            return (
              <div className="saved-card-row" key={index}>
                <input
                  type="radio"
                  id={`card_${card.pan}-${card.exp}-${card.bin}`}
                  name="card"
                  value={`${card.pan}-${card.exp}-${card.bin}`}
                  checked={
                    cardTokenData.card &&
                    `${cardTokenData.card.pan}-${cardTokenData.card.exp}-${cardTokenData.card.bin}` ===
                      `${card.pan}-${card.exp}-${card.bin}`
                  }
                  onChange={() =>
                    handleCardTokenDataChange({
                      target: { name: "card", value: card }
                    })
                  }
                />
                <label htmlFor={`card_${card.pan}-${card.exp}-${card.bin}`}>
                  <span className="saved-card-text">
                    {formatSavedCardLabel(card)}
                  </span>
                  {providerTags.length > 0 && (
                    <span
                      className="saved-card-provider-tags"
                      aria-label="Card token providers"
                    >
                      {providerTags.map((provider) => (
                        <span
                          className="saved-card-provider-tag"
                          key={provider.id}
                        >
                          {provider.label}
                        </span>
                      ))}
                    </span>
                  )}
                </label>
              </div>
            );
          })}
      </div>
      <button className="primary-action" type="submit">
        Pay
      </button>
    </form>
  );
}

export default WithdrawalCreditCardForm;
